import { History } from "lucide-react";
import type { WidgetDef } from "../types";
import { RecentGlance, RecentView } from "./RecentWidget";

export const recentWidget: WidgetDef<Record<string, never>> = {
  type: "recent",
  icon: History,
  title: "recent.title",
  description: "recent.description",
  sizes: ["s", "m", "l"],
  defaultSize: "s",
  defaultConfig: () => ({}),
  parseConfig: () => ({}),
  available: (me) => me.role !== "carrier",
  View: RecentView,
  Glance: RecentGlance,
};
